<section style="height: auto;" translate="no">
  <nav>
    <ol class="divbusca">
      <div class="div_busca_orientacao">
        <div class="item_pesquisa">
          <div class="tdTitilo">
            <label for="regiao" class="form-label">Região:</label>
          </div>
          <div class="tdCampo">
            <select (change)="onSelecionar(mySelectFiltroRegiao.value)" #mySelectFiltroRegiao name="select"
              aria-placeholder="Regiao" class="form-select">
              <option value="">Todos</option>
              <option *ngFor="let objeto of listaRegiao" value={{objeto.id}}>{{objeto.descricao}}</option>

            </select>
          </div>
        </div>
        <div class="item_pesquisa">
          <div class="tdTitilo">
            <label for="posto" class="form-label">Posto:</label>
          </div>
          <div class="tdCampo">
            <app-multiple-selection-select-all [lista]="listaPostos" [width]="larguraTela/2.5"
              [regiaoSelecionada]="RegiaoSelecionada"
              (infoClicada)="processarInfo($event)"></app-multiple-selection-select-all>
          </div>
        </div>
        <div class="tdTitilo">
          <button class="btn btn-primary btnpesquisa" (click)="filtrarPesquisa()" id="class-button"
            type="submit">Pesquisar</button>
        </div>
      </div>
    </ol>
  </nav>
</section>
<section translate="no">
  <section style="height: auto;">
    <nav>
      <ol class="cd-breadcrumb custom-separator">
        <table>
          <tbody>
            <tr>
              <td class="nomeTela">
                Relatório de Ponto Atendimento
              </td>
            </tr>
          </tbody>
        </table>
      </ol>
    </nav>
  </section>
  @if (SemDados == true) {
  <h4 class="alerta_busca">Não exite
    dados para serem mostrados
  </h4>
  }
  @if(feitaPesquisa)
  {
  <h4 class="alerta_busca">Escolha um
    posto para visualizar o relatório
  </h4>
  }
  @if(!feitaPesquisa && !SemDados)
  {
  <div class="div_buttons">
    <button type="button" (click)="exportToPDF()" class="btn btn-secondary" style="margin-right: 10px;">
      Exportar PDF<i class="fas fa-file-pdf fa-2xl" style="margin-left: 10px;"></i>
    </button>
    <button (click)="exportarParaExcel()" type="button" class="btn btn-secondary" style="margin-right: 10px;">
      Exportar Excel
      <i class="fas fa-file-excel fa-2xl" style="margin-left: 10px;"></i>
    </button>
  </div>
  <div class="tabela-wrapper">
    <div class="style-tabela">
      <table border="0" cellpadding="0" id="tableDados" cellspacing="0">
        <thead>
          <tr>
            <th class="cabecalho clique-para-ordenar" (click)="ordenarPorColuna('posto')">
              Posto             
              {{
                campoOrdenado === 'posto'
                  ? (direcaoOrdenacao === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
            </th>
            <th class="cabecalho clique-para-ordenar" (click)="ordenarPorColuna('ponto')">
              Ponto Atendimento             
              {{
                campoOrdenado === 'ponto'
                  ? (direcaoOrdenacao === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
            </th>
            <th class="cabecalho clique-para-ordenar" (click)="ordenarPorColuna('abertura')">
              Data Início / Hora              
              {{
                campoOrdenado === 'abertura'
                  ? (direcaoOrdenacao === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
            </th>
            <th class="cabecalho clique-para-ordenar" (click)="ordenarPorColuna('fechamento')">
              Data Fim / Hora             
              {{
                campoOrdenado === 'fechamento'
                  ? (direcaoOrdenacao === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
            </th>
            <th class="cabecalho clique-para-ordenar" (click)="ordenarPorColuna('status')">
              Status        
              {{
                campoOrdenado === 'status'
                  ? (direcaoOrdenacao === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
            </th>
          </tr>
        </thead>
        <tbody>
          @for (item of data; track item) {
          @for (itemPonto of item.pontosAtendimentos; track itemPonto) {
          @for (itemAtendimento of itemPonto.atendimentos; let i = $index; track itemAtendimento) {
          <tr>
            <!-- Posto sempre repetido -->
            @if (i === 0) {
            <td [attr.rowspan]="itemPonto.atendimentos.length">{{ item.descricao }}</td>
            }
            <!-- Ponto Atendimento com rowspan só na primeira linha -->
            @if (i === 0) {
            <td [attr.rowspan]="itemPonto.atendimentos.length">{{ itemPonto.descricao }}</td>
            }

            <td>{{ dateTimeFormatPipe.transform(itemAtendimento.abertura) }}</td>
            <td>{{ dateTimeFormatPipe.transform(itemAtendimento.fechamento) }}</td>

            <!-- Status com rowspan só na primeira linha -->
            @if (i === 0) {
            <td [attr.rowspan]="itemPonto.atendimentos.length">{{ itemPonto.status }}</td>
            }
          </tr>
          }
          }
          }
        </tbody>
      </table>
    </div>
  </div>
  }